import { saveAs } from "file-saver";
import {
  Typography,
  Card,
  CardContent,
  CardMedia,
  Box,
  //useTheme,
} from "@mui/material";
import { ROUTES } from "@/utils/navigation";
//import useResponsive from "@/hooks/useResponsive";

import ArrowRightIcon from "@/assets/icons/arrow-long-right.svg?react";
import ButtonWithIcon from "../../UI-Kit/ButtonWithIcon";
// import { CustomRating } from "@/components/UI-Kit/CustomRating";
import DownloadIcon from "@/assets/icons/arrow-down-tray.svg?react";
import { cardStyles, imageContainerStyles, imageStyles } from "./styles";
import { Link } from "react-router-dom";

interface IProps {
  product: IProduct;
  withRating?: boolean;
  withPrice?: boolean;
  withDownload?: boolean;
  withExplore?: boolean;
}

const ProductCard: React.FC<IProps> = ({
  product,
  withDownload = false,
  withPrice = false,
  withExplore = true,
  //withRating = true,
}) => {
  const {
    id,
    name,
    price,
    shortDescription,
    image,
    //rating = 5,
    userManualURL,
  } = product;
  // const theme = useTheme();
  // const isMobile = useResponsive("down", "md");

  return (
    <Card
      component={Link}
      to={`${ROUTES.trackingDevices}/${id}`}
      variant="outlined"
      sx={{
        ...cardStyles,
        gap: { xs: 2, md: 4 },
        height: "100%",
        maxWidth: { xs: 343, md: 492 },
        mx: "auto",
      }}
    >
      {/* Rating */}
      {/* {withRating && (
        <Box
          position="absolute"
          top={isMobile ? theme.spacing(2) : theme.spacing(3)}
          left={isMobile ? theme.spacing(2) : theme.spacing(3)}
          fontSize={0}
        >
          <CustomRating value={rating} readOnly size="large" />
        </Box>
      )} */}

      {/* Image */}
      <Box sx={imageContainerStyles}>
        <CardMedia component="img" image={image} alt={name} sx={imageStyles} />
      </Box>

      {/* Description */}
      <CardContent
        sx={{
          padding: "0 !important",
          flexGrow: 1,
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="start"
            gap={1}
            mb={{ xs: 1, md: 2 }}
          >
            <Typography variant="h4" component="h3" color="text.primary">
              {name}
            </Typography>
            {withPrice && (
              <Typography
                variant="h5"
                fontSize={{ xs: 16, md: 20, lg: 24 }}
                color="text.primary"
                component="p"
              >
                ${price}
              </Typography>
            )}
          </Box>
          <Typography
            variant="body1"
            color="text.secondary"
            mb={{ xs: 0.5, md: 2.5 }}
            fontSize={{ md: "1.125rem" }}
            dangerouslySetInnerHTML={{ __html: shortDescription }}
          ></Typography>
        </Box>

        <Box>
          {withDownload && userManualURL != "" && (
            <ButtonWithIcon
              label="Download PDF"
              IconComponent={DownloadIcon}
              onClick={() => saveAs(userManualURL, `UserManual_${name}.pdf`)}
            />
          )}

          {withExplore && (
            <ButtonWithIcon
              label="Explore"
              IconComponent={ArrowRightIcon}
              isLink={true}
              to={`${ROUTES.trackingDevices}/${id}`}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
